module.exports = __webpack_public_path__ + "static/media/content-4.f29ea433.svg";